import { render, staticRenderFns } from "./BottomBar.vue?vue&type=template&id=faf2305a&scoped=true"
import script from "./BottomBar.vue?vue&type=script&lang=js"
export * from "./BottomBar.vue?vue&type=script&lang=js"
import style0 from "./BottomBar.vue?vue&type=style&index=0&id=faf2305a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf2305a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faf2305a')) {
      api.createRecord('faf2305a', component.options)
    } else {
      api.reload('faf2305a', component.options)
    }
    module.hot.accept("./BottomBar.vue?vue&type=template&id=faf2305a&scoped=true", function () {
      api.rerender('faf2305a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/BottomBar.vue"
export default component.exports